<script setup lang="ts">
import { defineAsyncComponent, onMounted } from '#imports'

const YscLoader = defineAsyncComponent(() => import('./YscLoader.vue'))
const emit = defineEmits(['ready'])

interface Props {
  loading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
})

onMounted(async () => {
  emit('ready')
})
</script>

<template>
  <button
    type="submit"
    class="btn btn-primary text-sm sm:text-base"
    :disabled="props.loading"
  >
    <slot>
      {{ $t('commons.save') }}
    </slot>
    <YscLoader
      v-if="props.loading"
      class="ml-3 h-5 w-5"
      is-light
    />
  </button>
</template>
